import React from 'react';
import useSittingStore from '../../stores/sittingStore';

/**
 * WalkinNotificationCard — informs the doctor when a nurse or receptionist
 * has initiated a procedure on one of their visits.
 *
 * Feeds off useSittingStore().walkinNotifications (SITTING_WALKIN_NOTIFICATION
 * WS event). Dismiss-only — no action required. Auto-hides when the feed
 * is empty.
 */
export default function WalkinNotificationCard({ memberId, isDark }) {
  const walkinNotifications = useSittingStore((s) => s.walkinNotifications);
  const dismiss = useSittingStore((s) => s.dismissWalkinNotification);

  const mine = (walkinNotifications || []).filter((n) => {
    if (!memberId) return true;
    return (
      n.doctor_member_id === memberId
      || n.visit_doctor_member_id === memberId
      || !n.doctor_member_id
    );
  });

  if (mine.length === 0) return null;

  const border = isDark ? 'rgba(234,179,8,0.3)' : 'rgba(234,179,8,0.25)';
  const bg = isDark ? 'rgba(234,179,8,0.08)' : 'rgba(234,179,8,0.06)';

  return (
    <div
      style={{
        borderRadius: '0.625rem',
        border: `1px solid ${border}`,
        background: bg,
        padding: '0.625rem 0.75rem',
        marginBottom: '0.5rem',
      }}
    >
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: '0.5rem', marginBottom: mine.length > 0 ? '0.375rem' : 0,
      }}>
        <span style={{
          fontSize: '0.6875rem', fontWeight: 600,
          color: isDark ? '#fbbf24' : '#a16207',
        }}>
          🔔 Walk-in procedures on your visits
        </span>
        <span style={{
          fontSize: '0.625rem',
          color: isDark ? '#ca8a04' : '#a16207',
        }}>
          {mine.length} new
        </span>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
        {mine.slice(0, 5).map((n) => (
          <div
            key={n.sitting_id}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              gap: '0.5rem',
              padding: '0.375rem 0.5rem',
              borderRadius: '0.375rem',
              background: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(255,255,255,0.5)',
              border: `1px solid ${isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.04)'}`,
            }}
          >
            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{
                fontSize: '0.75rem', fontWeight: 600,
                color: isDark ? '#e8e9ed' : '#111827',
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}>
                {n.procedure_name || 'Procedure'}
                {n.patient_name ? ` · ${n.patient_name}` : ''}
              </div>
              <div style={{
                fontSize: '0.625rem',
                color: isDark ? '#9ca3af' : '#6b7280',
              }}>
                Initiated by {n.initiated_by_role || 'staff'}
                {n.initiated_by_name ? ` · ${n.initiated_by_name}` : ''}
              </div>
            </div>
            <button
              type="button"
              onClick={() => dismiss(n.sitting_id)}
              style={{
                fontSize: '0.625rem',
                padding: '0.25rem 0.5rem',
                borderRadius: '0.375rem',
                border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
                background: 'transparent',
                color: isDark ? '#9ca3af' : '#6b7280',
                cursor: 'pointer',
              }}
            >
              Dismiss
            </button>
          </div>
        ))}
        {mine.length > 5 && (
          <span style={{
            fontSize: '0.625rem',
            color: isDark ? '#9ca3af' : '#6b7280',
            textAlign: 'center',
          }}>
            +{mine.length - 5} more
          </span>
        )}
      </div>
    </div>
  );
}
